module.exports = __webpack_public_path__ + "img/logo.e246d6f0.png";